import React from "react";
import { Navigate, useRoutes, useNavigate } from "react-router-dom";

import MaxLayout from "../components/layout/MaxLayout";
import Home from "../pages/Home";
import Results from "../pages/Results";
import Rewards from "../pages/Rewards";
import GameLobby from "../pages/GameLobby";
import { RoutePaths } from "../common/RoutePaths";
import MatchResultSummaryPopUp from "../components/results/MatchResultSummaryPopUp";
import { AppImages } from "../common/ImagePath";
import SpinWheel from "../pages/SpinWheel";
import { useLaunch } from "../../auth/useAuth";

// Entry point for the launch flow: when the wrapper iframe loads
// `/game?gameId=...`, send the user to the corresponding lobby.
function LaunchRedirect() {
  const { launchParams } = useLaunch();
  const gameId = launchParams?.gameId;
  if (!gameId) {
    return <Navigate to={RoutePaths.HOME} replace />;
  }
  return (
    <Navigate
      to={RoutePaths.GAME_LOBBY.replace(":gameId", gameId)}
      replace
    />
  );
}

function MatchResultSummaryPopUpRoute() {
  const navigate = useNavigate();
  return (
    <MatchResultSummaryPopUp
      amount={4}
      userName="JTMoney"
      userScore={53}
      opponentName="WraithFrost8102"
      opponentScore={23}
      sunburstImage={AppImages.radialPattern}
      onMatchStats={() => console.log('open stats')}
      status="win"
      onClose={() => navigate(RoutePaths.HOME)}
    />
  );
}

const routes = (isLoggedIn) => [
  {
    path: RoutePaths.HOME,
    element: isLoggedIn ? <MaxLayout /> : <Navigate to={RoutePaths.HOME} />,
    children: [
      {
        element: <Home />,
        path: RoutePaths.HOME,
        index: true,
      },
      {
        element: <Results />,
        path: RoutePaths.RESULTS,
      },
      {
        element: <Rewards />,
        path: RoutePaths.REWARDS,
      },
      {
        element: <LaunchRedirect />,
        path: RoutePaths.GAME_LAUNCH,
      },
      {
        element: <GameLobby />,
        path: RoutePaths.GAME_LOBBY,
      },
      {
        element: <SpinWheel />,
        path: RoutePaths.SPIN_WHEEL,
      },
      {
        element: <MatchResultSummaryPopUpRoute />,
        path: '/test',
      },
      {
        element: <Navigate to={RoutePaths.HOME} />,
        path: "*",
      },
    ],
  },
];

export default function Routes(props) {
  const { isLoggedIn } = props;
  return useRoutes(routes(isLoggedIn));
}
